import { theme } from "components/lib/utils/theme";

export const PasswordToggleStyles = {
  lineHeight: theme.space[4],
  width: theme.space[6],
  color: theme.colors.grey.text,
};
